export function getYearsOfExperience(startYear = 2018, startMonth = 5) {
  const start = new Date(startYear, startMonth);
  const now = new Date();

  let years = now.getFullYear() - start.getFullYear();

  const hasNotReachedAnniversary =
    now.getMonth() < start.getMonth() ||
    (now.getMonth() === start.getMonth() && now.getDate() < start.getDate());

  if (hasNotReachedAnniversary) {
    years -= 1;
  }

  return years;
}
